import type { FC } from 'react';
import type { SportLineDisplayVariant } from '@mwl/core-lib';
import ArrowIcon from '@public/assets/common/icons/arrowUpDouble.svg';
import { ButtonIcon } from '@/components/ButtonIcon/ButtonIcon';
import { getOutrightAnalytics } from '@/components/GroupedLines/components/GroupedLinesSportHeader/GroupedLinesSportHeader.analytics';
import type { LineOutrightWithEntities } from '@/components/GroupedLines/GroupedLines.types';
import { SportIcon } from '@/components/SportIcon/SportIcon';
import { SportLink } from '@/components/SportLink/SportLink';
import { useSportLinks } from '@/hooks';
import type { LineWithEntities } from '@/types';
import styles from './GroupedLinesSportHeader.module.scss';
interface GroupedLinesSportHeaderProps {
  line: LineWithEntities | LineOutrightWithEntities;
  isInSearch?: boolean;
  variant?: SportLineDisplayVariant;
  isOpen?: boolean;
  handleToggle?: () => void;
  lineCount?: number;
}
export const GroupedLinesSportHeader: FC<GroupedLinesSportHeaderProps> = ({
  line,
  isInSearch,
  variant,
  handleToggle,
  isOpen,
  lineCount
}) => {
  const {
    sportIcon
  } = useSportLinks({
    data: line,
    styles,
    options: {
      isInSearch,
      isCyberSportPage: true
    }
  });
  if (variant === 'OUTRIGHT') {
    const analytics = getOutrightAnalytics(line?.sport?.title, isOpen);
    return <div className={styles.header}>
        <div className={cn(styles.sportLink, styles.outrightSportLink)}>
          <SportIcon className={styles.icon} size={20} url={sportIcon} />
          {line.sport.title}
        </div>
        <ButtonIcon as="button" size="xs" onClick={handleToggle} className={styles.arrowButton} aria-label="line toggle" analytics={analytics}>
          <ArrowIcon className={cn(styles.arrow, {
          [styles.active]: isOpen
        })} />
        </ButtonIcon>
      </div>;
  }
  return <div className={styles.root} data-sentry-component="GroupedLinesSportHeader" data-sentry-source-file="GroupedLinesSportHeader.tsx">
      <SportLink sport={line.sport} className={styles.sportLink} data-sentry-element="SportLink" data-sentry-source-file="GroupedLinesSportHeader.tsx">
        <SportIcon className={styles.icon} size={20} url={sportIcon} data-sentry-element="SportIcon" data-sentry-source-file="GroupedLinesSportHeader.tsx" />
        {line.sport.title}
      </SportLink>
      {lineCount && lineCount > 1 && <div className={styles.counter}>{lineCount}</div>}
    </div>;
};